// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { Cursors } from '@shared/commons/Cursors';
import { TerceraChartBaseRenderer } from '../TerceraChartBaseRenderer';
import { MouseButtons } from '@front/controls/UtilsClasses/ControlsUtils';
import { TerceraChartUtils } from '../../TerceraChartUtils';
import { ThemeManager } from '@front/controls/misc/ThemeManager';
import { TerceraChartToolRenderer } from './TerceraChartToolRenderer';
import { Pen, SolidBrush } from '@shared/commons/Graphics';
import { LayersEnum } from '../../Utils/LayersEnum';
export class TerceraChartSelectionRenderer extends TerceraChartBaseRenderer {
    constructor(chart) {
        super(chart);
        this.selectRect = Rectangle.Empty();
        this.Active = false;
        this.pressed = false;
        this.windowToSelectTools = null;
        this.ThemeChanged();
        this.assignLayer = LayersEnum.Tools;
        this.SetClassName('TerceraChartSelectionRenderer');
    }
    SelectTools() {
        if (isNullOrUndefined(this.windowToSelectTools)) {
            return;
        }
        const toolRenderer = this.windowToSelectTools.GetRenderer(TerceraChartToolRenderer);
        if (isNullOrUndefined(toolRenderer)) {
            return;
        }
        toolRenderer.SelectToolsByRect(TerceraChartUtils.AbsRectangle(this.selectRect));
    }
    ProcessMouseDown(e) {
        if (this.Active && e.Button == MouseButtons.Left) {
            this.pressed = true;
            this.selectRect.X = e.X;
            this.selectRect.Y = e.Y;
            this.windowToSelectTools = this.chart.GetWindowByPoint(e.Location);
            return true;
        }
        return super.ProcessMouseDown(e);
    }
    ProcessMouseMove(e) {
        if (this.Active) {
            if (this.pressed) {
                this.selectRect.Width = e.X - this.selectRect.X;
                this.selectRect.Height = e.Y - this.selectRect.Y;
                e.NeedRedraw |= LayersEnum.Tools | LayersEnum.CrossHair;
            }
            else {
                e.NeedRedraw |= LayersEnum.CrossHair;
            }
        }
        return super.ProcessMouseMove(e);
    }
    ProcessMouseUp(e) {
        this.pressed = false;
        if (this.Active && e.Button == MouseButtons.Left) {
            this.SelectTools();
            this.selectRect = Rectangle.Empty();
        }
        return super.ProcessMouseDown(e);
    }
    Draw(gr, window, windowsContainer, advParams = null) {
        if (this.Active && this.pressed && this.windowToSelectTools != null) {
            const clientRect = this.windowToSelectTools.ClientRectangle;
            gr.save();
            gr.beginPath();
            gr.rect(clientRect.X, clientRect.Y, clientRect.Width, clientRect.Height);
            gr.clip();
            const absRect = TerceraChartUtils.AbsRectangle(this.selectRect);
            gr.DrawRect(this.pen, absRect.X, absRect.Y, absRect.Width, absRect.Height);
            gr.FillRect(this.brush, absRect.X, absRect.Y, absRect.Width, absRect.Height);
            // Reset clip.
            gr.restore();
        }
        super.Draw(gr, window, windowsContainer, advParams);
    }
    Dispose() {
        this.chart = null;
        super.Dispose();
    }
    ThemeChanged() {
        super.ThemeChanged();
        this.pen = new Pen(ThemeManager.colors.Chart_ToolSelectorRectPenColor);
        this.brush = new SolidBrush(ThemeManager.colors.Chart_ToolSelectorRectBrushColor);
    }
    GetCursor(e) {
        if (this.Active) {
            for (let i = 0; i < this.chart.windowsContainer.Windows.length; i++) {
                if (this.chart.windowsContainer.Windows[i].ClientRectangle.Contains(e.Location.X, e.Location.Y)) {
                    return Cursors.Cross;
                }
            }
        }
        return null;
    }
}
